import { Col, Row } from 'antd';
import React from 'react';
import { PaymentDetails, PaymentIncentiveCard } from '../../components';
import { ServicesPayment } from '../services-payment';

const PaymentDetailsDashboard: React.FC<any> = () => {
	return (
		<div className="dashboard" style={{ width: '95%', paddingBottom: '2rem' }}>
			<Row>
				{/* <h1 className="mb-5">Payment Details</h1> */}
				<h1 className="mb-5">Services</h1>
			</Row>
			<Row
				gutter={24}
				className="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center align-items-md-start"
			>
				<Col xs={24} md={16} className="mb-3 mb-md-0">
					{/* <PaymentDetails className="mb-5" /> */}
					<ServicesPayment />
				</Col>
				<Col xs={24} md={8} className="d-felx ">
					<PaymentIncentiveCard />
				</Col>
			</Row>
		</div>
	);
};

export default PaymentDetailsDashboard;
